import { Box, styled } from '@mui/material';
import React, { useCallback } from 'react';

import ActionsCellRenderer from './ActionsCellRenderer';
import AgContainer from 'routes/BudgetModule/components/BudgetProposal/Resource/ExpenseIncome/components/AgContainer';
import { AgGridReact } from 'ag-grid-react';
import { GetRowIdParams } from 'ag-grid-community';
import Loading from 'components/Loading';
import { UserGroupSummaryT } from 'business/definitions';
import { getColDefs } from './colDefinitions';
import { useTranslation } from 'react-i18next';

const StyAgContainer = styled(AgContainer, { name: 'StyAgContainer' })(
    ({ theme }) => ({
        border: '1px solid lightgray',
        margin: '0.5rem',
        width: 'auto',
        flex: 15,
        '.ag-header-row': { backgroundColor: theme.palette.lightGrey },
        '.ag-header-cell': {
            borderRight: '1px solid lightgray',
            textAlign: 'center',
        },
        '.ag-header-cell-label': {
            justifyContent: 'center',
        },
        '.ag-header-cell-text': {
            textTransform: 'unset !important',
            color: `${theme.palette.darkGrey} !important`,
        },
    }),
);

type UserGroupsGridProps = {
    userGroups: UserGroupSummaryT[];
    isLoading: boolean;
};

const UserGroupsGrid = ({
    userGroups,
    isLoading,
}: UserGroupsGridProps): JSX.Element => {
    const { t } = useTranslation();

    const colDefs = getColDefs(userGroups, t);
    const getRowId = useCallback(
        (params: GetRowIdParams) => params.data.id,
        [],
    );
    return (
        <>
            {isLoading ? (
                <Box sx={{ flex: 15 }}>
                    <Loading />
                </Box>
            ) : (
                <StyAgContainer className="ag-theme-material">
                    <AgGridReact
                        rowHeight={40}
                        headerHeight={50}
                        getRowId={getRowId}
                        rowData={userGroups}
                        overlayNoRowsTemplate={t(
                            'adminSpace.userGroupsList.noUserGroup',
                        )}
                        components={{
                            actionsCellRenderer: ActionsCellRenderer,
                        }}
                        columnDefs={colDefs}
                        defaultColDef={{
                            suppressMenu: true,
                            suppressMovable: true,
                        }}
                        animateRows={false}
                    />
                </StyAgContainer>
            )}
        </>
    );
};

export default UserGroupsGrid;
